import styled from 'styled-components';
import { px2rem } from '../../utils/helpers/style.js';
import { Popover } from '../../Popover/Popover.web.js';
import { fontFamilyStyles } from '../../ContentText/styles.web.js';
import { spacing } from '../../constants/spacing.js';
import { styles } from '../../constants/styles.js';

var wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-pwzimq-0"
})(["display:flex;align-items:center;height:", ";"], px2rem(80));
var buttonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__buttonWrapper",
  componentId: "sc-pwzimq-1"
})(["display:flex;flex-wrap:nowrap;align-items:center;justify-content:center;height:", ";min-width:", ";"], px2rem(80), px2rem(80));
var language = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__language",
  componentId: "sc-pwzimq-2"
})(["", ";font-size:", ";background:none;border:none;display:flex;align-items:center;padding-left:", ";padding-right:", ";color:", ";cursor:pointer;height:", ";transition:color ", ";transition-timing-function:", ";&:hover,&:focus{color:", ";}"], fontFamilyStyles, px2rem(14), spacing.xxxs, spacing.xxxs, function (props) {
  return props.$color;
}, px2rem(80), styles.transition.timing.slowest, styles.transition["function"].base, function (props) {
  return props.$hoverColor;
});
var separator = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__separator",
  componentId: "sc-pwzimq-3"
})(["&:after{", ";content:'|';height:100%;display:flex;align-items:center;}"], fontFamilyStyles);
var popover = /*#__PURE__*/styled(Popover).withConfig({
  displayName: "styles__popover",
  componentId: "sc-pwzimq-4"
})(["color:", ";padding-top:0;padding-bottom:0;padding-left:", ";padding-right:", ";", ":hover,", ":focus{color:", ";}"], function (p) {
  return p.theme.colors.text;
}, spacing.xs, spacing.xs, language, language, function (p) {
  return p.theme.colors.primary;
});

export { buttonWrapper, language, popover, separator, wrapper };
